import { render } from "./ShowChannel.vue?vue&type=template&id=72ccff5a"
import script from "./ShowChannel.vue?vue&type=script&lang=js"
export * from "./ShowChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__